import SettingsSubSection from '../../../../../components/common/SettingsSubSection';
import ColorPickerWithDefault from '../../../../components/inputs/ColorPickerWithDefault';
import { useViewColorValue } from '../../hooks/view-forms';

export function CityPairSettings() {
    const activeColor = useViewColorValue((x) => x.plane.settings.cityPair.activeColor);
    const plannedColor = useViewColorValue((x) => x.plane.settings.cityPair.plannedColor);
    const scheduledColor = useViewColorValue((x) => x.plane.settings.cityPair.scheduledColor);

    return (
        <div className="px-3">
            <SettingsSubSection title="City pair line colors">
                <div className="d-flex gap-3">
                    <div>
                        <div>Active color</div>
                        <ColorPickerWithDefault {...activeColor} defaultColor="#5585f5" />
                    </div>
                    <div>
                        <div>Planned color</div>
                        <ColorPickerWithDefault {...plannedColor} defaultColor="#00dc00" />
                    </div>

                    <div>
                        <div>Scheduled color</div>
                        <ColorPickerWithDefault {...scheduledColor} defaultColor="#ebebc8" />
                    </div>
                </div>
            </SettingsSubSection>
        </div>
    );
}
